
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.531","height":"13.141","viewBox":"0 0 14.531 13.141"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_52","data-name":"Group 52","transform":"translate(-132.357 -1.533)","fill":"#196cae"}},[_c('path',{attrs:{"id":"Path_354","data-name":"Path 354","d":"M156.148 41.1l8.6-7.551 2.774 2.435-8.6 7.551z","transform":"translate(-22.446 -30.205)"}}),_c('path',{attrs:{"id":"Path_355","data-name":"Path 355","d":"M132.357 201.146l2.938-.814-2.124-2.124z","transform":"translate(0 -186.472)"}}),_c('path',{attrs:{"id":"Path_356","data-name":"Path 356","d":"M318.679 1.946a1.413 1.413 0 00-2 0l-.6.6 2.664 2.654.6-.6a1.413 1.413 0 000-2z","transform":"translate(-172.866)"}})])])
          )
        }
      }
    